import { render } from "./AddSalaryGradeView.vue?vue&type=template&id=17898c5a&scoped=true"
import script from "./AddSalaryGradeView.vue?vue&type=script&lang=js"
export * from "./AddSalaryGradeView.vue?vue&type=script&lang=js"

import "./AddSalaryGradeView.vue?vue&type=style&index=0&id=17898c5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17898c5a"]])

export default __exports__